import styled from 'styled-components';

export const SearchResultTab= styled.div`
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.backSub};
`;